/**
 * @file Entry point.
 *
 * Finds the DOM hosts, builds the game and starts it. Everything else lives
 * behind {@link ./core/Game.js Game}, so this file stays a bootstrapper.
 */

import { Game } from './core/Game.js';

const canvas = /** @type {HTMLCanvasElement | null} */ (document.getElementById('game-canvas'));
const ui = document.getElementById('ui-root');

if (!canvas || !ui) {
  throw new Error('Missing #game-canvas or #ui-root in the document.');
}

const game = new Game({ canvas, ui });
game.start();

// Dev-only inspection handle. Stripped from production builds, and nothing in
// the game ever reads it — the architecture stays free of globals (GDD §18).
if (import.meta.env.DEV) {
  /** @type {any} */ (window).__spin = game;
}

// Vite hot reload: dispose the previous instance so listeners, GPU resources
// and the audio context never accumulate across edits.
if (import.meta.hot) {
  import.meta.hot.dispose(() => game.dispose());
}
